import * as React from 'react';
import { createStyles, Theme, WithStyles, withStyles } from '@material-ui/core/styles';
import { DeepReadonly } from 'utility-types';
import { IOrganization } from '@pec/aion-ui-core/interfaces/organization';
import { IUserOrganization } from '@pec/aion-ui-core/interfaces/userOrganization';
import { Location } from 'history';
import { MobileAppBar } from './MobileAppBar';
import { MobileDrawer } from './MobileDrawer';

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      display: 'flex',
      justifyContent: 'flex-start',
      height: '100%'
    },
    content: {
      paddingTop: 56,
      [theme.breakpoints.up('sm')]: { paddingTop: 64 },
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      width: 0,
      height: '100%'
    }
  });

export type OwnProps = {
  title?: string;
  handleLogOut: () => void;
  sideNav?: JSX.Element;
  includeCompanySearch: boolean;
  organizationId?: string;
  location: Location;
  userOrganizations: DeepReadonly<IUserOrganization[]> | null;
  organization: DeepReadonly<IOrganization> | null;
};

export type Props = WithStyles<typeof styles> & OwnProps;

export type State = {
  open: boolean;
};

class MobileNavComponent extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      open: false
    };
  }

  toggleDrawer = () => {
    this.setState(prevState => ({
      open: !prevState.open
    }));
  };

  render() {
    const {
      classes,
      title,
      handleLogOut,
      children,
      sideNav,
      organizationId,
      includeCompanySearch,
      location,
      userOrganizations,
      organization
    } = this.props;

    return (
      <div className={classes.root}>
        <MobileAppBar includeCompanySearch={includeCompanySearch} title={title} toggleDrawer={this.toggleDrawer} />
        <MobileDrawer
          handleLogOut={handleLogOut}
          toggleDrawer={this.toggleDrawer}
          open={this.state.open}
          sideNav={sideNav}
          organization={organization}
          organizationId={organizationId}
          location={location}
          userOrganizations={userOrganizations}
        />
        <div className={classes.content}>{children}</div>
      </div>
    );
  }
}

export const MobileNav = withStyles(styles)(MobileNavComponent);
